var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",staticClass:"text-left mt-5 mb-6 md:mt-10 md:mb-8",class:{
    'text-sm': _vm.textSize === 'sm',
    'text-xl': _vm.textSize === 'xl',
    'text-2xl': _vm.textSize === '2xl',
    'text-3xl': _vm.textSize === '3xl',
    'text-4xl': !_vm.textSize,
  }},[_c('span',{staticClass:"block",class:{
      'font-light': !_vm.inverseStyleStatus,
      'font-extralight': _vm.inverseStyleStatus,
      'text-brand-headlines': !_vm.inverseStyleStatus,
      'text-black': _vm.inverseStyleStatus,
    }},[_vm._t("default")],2),_vm._v(" "),(_vm.subtitle && _vm.displaySubtitle)?_c('span',{staticClass:"block uppercase tracking-widest",class:{
      'font-light': _vm.inverseStyleStatus,
      'font-extralight': !_vm.inverseStyleStatus,
      'text-brand-headlines': _vm.inverseStyleStatus,
      'text-black': !_vm.inverseStyleStatus,
    }},[_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }